import React, { Component } from "react";
import { withRouter, Route } from "react-router-dom";
import { connect } from "react-redux";
import { css } from "styled-components";
import { withTranslation, withNamespaces } from "react-i18next";

// styles
import style from "../../Styles/Containers/Product.module.css";

// component
import Header from "../../Components/Header/header";
import Section from "../../Components/Section";
import TapSelector from "../../Components/TapSelector";
import AuthCount from "../../Components/AuthCount";
import HistoryList from "../../Components/HistoryList";
import HashTag from "../../Components/HashTag";
import ProductBanner from "../../Components/ProductBanner";
import ProduceHistory from "../../Components/ProduceHistory";
import DistributionHistory from "../../Components/DistributionHistory";
import CameraFooter from "../../Components/Footer/cameraFooter";
import Magnetic from "../../Components/Magnetic";
import Spinner from "../../Components/Spinner";
import { CloudfrontImage } from "../../Components/CloudfrontAsset";

// Actions
import { action } from "../../Data";
import * as Const from "../../Data/const";
import { logClientEvent } from "../../Lib/clientEventLog";

class ProductContainer extends Component {
    constructor() {
        super();
        this.state = {
            isDetail: false, // 인증이 아닌 단순히 상세 페이지를 볼때 true
            selectedTap: 0,
            taps: [],
            modalVisible: false,
            translate: {
                en: {},
                kr: {},
                cn: {}
            },
            layoutIndex: 0,
            product: {},
            productConfirmStep: {},
            productMark: {},
            event: {},
            logProductConfirm: {},
            confirmCount: 0,
            isLoading: true,
            productLoadFailed: false,
            codeProduct: {},
            ELocale: "en"
        };
        this.setTabs = this.setTabs.bind(this);
        this.getProductInfo = this.getProductInfo.bind(this);
        this.getParameterByName = this.getParameterByName.bind(this);
        this.handleHashtagLink = this.handleHashtagLink.bind(this);

        this.handleDistributorListOpen = this.handleDistributorListOpen.bind(this);
    }

    componentDidMount() {
        let query = Const.parseUrlParameter(this.props.location.search);

        let q = {};
        if (query.company_id && query.product_id) {
            q.company_id = query.company_id;
            q.product_id = query.product_id;
            this.setState({ isDetail: true });
        } else {
            q.productReleaseCode = query.id;
        }

        this.getProductInfo(q);
    }
    setTabs(product) {
        let taps = [];
        //// 3단탭 적용
        // 1단
        if (
            product[this.state.ELocale].detail_title &&
            product[this.state.ELocale].detail_title.length > 0
        ) {
            taps.push(product[this.state.ELocale].detail_title);
        } else {
            taps.push(this.props.t("product_detail"));
        }
        // 2단
        if (
            product[this.state.ELocale].detail2_title &&
            product[this.state.ELocale].detail2_title.length > 0
        ) {
            taps.push(product[this.state.ELocale].detail2_title);
        }
        // 3단
        if (
            product[this.state.ELocale].detail3_title &&
            product[this.state.ELocale].detail3_title.length > 0
        ) {
            taps.push(product[this.state.ELocale].detail3_title);
        }
        // 인증이력
        if (product.allow.indexOf("dist_history") > -1) {
            taps.push(this.props.t("distribution_history"));
        }

        this.setState({
            taps: taps
        });
    }
    async getProductInfo(q) {
        var allElements = document.getElementsByTagName("img");

        for (var i = 0; i < allElements.length; i++) {
            var element = allElements[i];
            delete element.style;
        }

        // 참가 여부 true이면 이벤트 페이지로 이동
        let eventJoin = this.getParameterByName("eventJoin");
        if (!q.productReleaseCode && !(q.company_id && q.product_id)) {
            Const.showAlert("", "파라미터로 전달받은 코드가 없습니다.");
            this.setState({ isLoading: false });
            return;
        }

        let locale = this.getParameterByName("locale");

        if (locale && Const.COUNTRY_CODES.indexOf(locale) == -1) locale = null;

        q.uuid = this.props.UUID;
        q.ELocale = locale || this.props.COUNTRY_CODE;

        const productReleaseCodeForLog = q.productReleaseCode || this.getParameterByName("id");
        const productInfoStartedAt = Date.now();
        logClientEvent("product_info_api_start", {
            productReleaseCode: productReleaseCodeForLog,
            isDetail: this.state.isDetail,
            uuidSource: window.__nbLastUUIDSource
        });

        this.props
            .dispatch(action.eUSER.getProductInfo(q))
            .then(response => {
                if (response.event && eventJoin !== "true" && !this.state.isDetail) {
                    this.setState({ event: response.event }, () => {
                        if (Const.checkDevice() === "web") {
                            this.props.history.push(
                                "/user/event?event_id=" +
                                this.state.event._id +
                                "&id=" +
                                q.productReleaseCode
                            );
                            this.setState({ modalVisible: true });
                        } else {
                            this.props.history.push(
                                "/user/event?event_id=" +
                                this.state.event._id +
                                "&id=" +
                                q.productReleaseCode
                            );
                        }
                    });
                }

                let nextLocale =
                    locale ||
                    this.props.COUNTRY_CODE ||
                    (response.product || {}).ELocale ||
                    "en";

                if (
                    response.product &&
                    response.product._id &&
                    !response.product[nextLocale]
                ) {
                    nextLocale =
                        ["cn", "en", "kr"].find(item => response.product[item]) ||
                        nextLocale;
                }

                if (
                    !response.product ||
                    !response.product._id ||
                    !response.product[nextLocale]
                ) {
                    throw new Error("PRODUCT_INFO_INVALID");
                }

                logClientEvent("product_info_api_success", {
                    productReleaseCode: productReleaseCodeForLog,
                    durationMs: Date.now() - productInfoStartedAt,
                    hasProduct: !!(response.product && response.product._id),
                    hasEvent: !!response.event
                });

                this.setState(
                    {
                        isLoading: false,
                        productLoadFailed: false,
                        productReleaseCode: (response.codeProduct || {}).code,
                        product: response.product || {},
                        layoutIndex: response.product.layoutIndex || 1,
                        logProductConfirmList: response.logProductConfirmList || [],
                        productConfirmStep: response.productConfirmStep || {},
                        logTakeOverList: response.logTakeOverList || [],
                        productMark: response.productMark || {},
                        confirmCount: response.confirmCount || 0,
                        codeProduct: response.codeProduct || {},
                        ELocale: nextLocale
                    },
                    () => {
                        let logTakeOverList = this.state.logTakeOverList.map(item => {
                            item.isOpen = false;
                            return item;
                        });

                        // 인수내역만
                        let newList = [];
                        for (let item of logTakeOverList) {
                            if (item.handOverEaTotal == -1) {
                                newList.push(item);
                            }
                        }

                        this.setState({ logTakeOverList: newList });
                        this.setTabs(response.product);
                    }
                );
            })
            .catch(err => {
                logClientEvent("product_info_api_fail", {
                    severity: "error",
                    productReleaseCode: productReleaseCodeForLog,
                    durationMs: Date.now() - productInfoStartedAt,
                    message: err && err.message,
                    response: err && err.response && err.response.data
                });
                this.setState(
                    {
                        isLoading: false,
                        productLoadFailed: true
                    },
                    () => {
                        if (err.response) {
                            let errData = Const.getError(
                                err.response.data,
                                this.props.COUNTRY_CODE
                            );
                            if (!errData.code) {
                                Const.showAlert("", errData.errorMessage);
                                return;
                            }
                            if (errData.code === "PRODUCT_AUTH_WRONG") {
                                // 이 부분 수정
                                // this.props.history.push('/user/auth/error?id=' + productReleaseCode);
                                this.props.history.push(
                                    "/user/auth/error?id=" + q.productReleaseCode
                                );
                            } else if (errData.code === "PRODUCT_AUTH_EXPIRED") {
                                Const.showAlert("", errData.errorMessage);
                                Const.userAppCloseActivity();
                            } else if (errData.code === "PRODUCT_AUTH_DENIED") {
                                Const.showAlert("", errData.errorMessage);
                                Const.userAppCloseActivity();
                            }
                        } else {
                            console.log("Unknown err", err);
                        }
                    }
                );
            });
    }

    getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    handleHashtagLink(tag) {
        let href;

        let hashtag = tag.trim();

        if (this.props.COUNTRY_CODE === "cn") {
            href =
                "https://www.tiktok.com/tag/" +
                hashtag +
                "?langCountry=" +
                this.state.ELocale +
                "&enter_from=h5_t";
        } else {
            href = "https://www.instagram.com/explore/tags/" + hashtag;
        }

        if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.iosHandler
        ) {
            Const.goLinkInIOS(href);
        } else {
            window.open(href);
        }
    }

    onClickTap(index) {
        if (this.state.selectedTap === index) return;
        this.setState({ selectedTap: index });
    }

    handleDistributorListOpen(index) {
        let newLogDistributorList = this.state.logTakeOverList;
        newLogDistributorList[index].isOpen = !newLogDistributorList[index].isOpen;

        this.setState({ logTakeOverList: newLogDistributorList });
        console.log(this.state.logTakeOverList);
    }

    get renderFirstSection() {
        return (
            <Section customStyle={{ marginTop: 0 }}>
                <ProductBanner
                    imgUrl={
                        this.state.product.brandLogo || this.state.product.companyLogoUrl
                    }
                    imageUrlList={
                        (this.state.product[this.state.ELocale] || {}).images || []
                    }
                    description={this.props.t("authenticated")}
                    code={this.state.productReleaseCode}
                    layoutIndex={this.state.product.layoutIndex}
                    imgCustomStyle={{ marginTop: this.state.isDetail ? "27px" : "" }}
                />
                <div className={style.sectionInfo}>
          <span className={style.sectionInfoTitle}>
            {this.state.product
                ? (this.state.product[this.state.ELocale] || {}).name
                : "이름 없음"}
          </span>
                    <span className={style.sectionInfoDetail}>
            <span className={style.textBold} style={{ marginRight: 8 }}>
              {this.props.t("manufacturer")}
            </span>
                        {this.state.product[this.state.ELocale + "CompanyName"]}
          </span>
                </div>
            </Section>
        );
    }

    get renderSecondSection() {
        return (
            <Section>
                <AuthCount
                    count={this.state.confirmCount}
                    authImage={this.state.productMark[this.state.ELocale + "Url"]}
                    countImage={this.state.productConfirmStep.images}
                    layoutIndex={this.state.layoutIndex}
                    confirmInfo={
                        this.state.product[this.state.ELocale].confirmInfo ||
                        this.props.t("number_of_authentications")
                    }
                />
            </Section>
        );
    }

    get renderMagnetic() {
        let productLocale = this.state.product[this.state.ELocale] || {};
        return productLocale.isMagnetic ? (
            <Magnetic
                onClick={() => {
                    if (!productLocale.url) {
                        Const.showAlert("", "전달 받은 url이 없습니다.");
                        return;
                    }
                    if (
                        window.webkit &&
                        window.webkit.messageHandlers &&
                        window.webkit.messageHandlers.iosHandler
                    ) {
                        Const.goLinkInIOS(productLocale.url);
                    } else {
                        window.open(productLocale.url);
                    }
                }}
            />
        ) : null;
    }

    get renderThirdSection() {
        const { selectedTap } = this.state;
        const histories = this.state.logProductConfirmList;

        console.log(histories);

        for (let item of this.state.logTakeOverList) {
            let index = this.state.logTakeOverList.indexOf(item);
            Object.assign(item, {
                isOpen: item.isOpen,
                mapUrl: item.takeOverMapUrl || item.handOverMapUrl,
                onClick: () => this.handleDistributorListOpen(index)
            });
        }

        const distributions = this.state.logTakeOverList;

        return (
            <>
                {this.renderTapSelector}
                {selectedTap < this.state.taps.length && this.renderHashTag}
                {selectedTap < this.state.taps.length && this.renderShopUrl}
                {selectedTap < this.state.taps.length && this.renderCompanyUrl}
                {selectedTap === 1 && (
                    <>
                        <ProduceHistory
                            codeProduct={this.state.codeProduct}
                            product={this.state.product}
                            ELocale={this.state.ELocale}
                        />
                        {distributions.length > 0 ? (
                            <Section title={this.props.t("distribution_details")}>
                                <DistributionHistory
                                    histories={distributions}
                                    ELocale={this.state.ELocale}
                                />
                            </Section>
                        ) : null}
                        {histories.length > 0 ? (
                            <Section title={this.props.t("scan_list")}>
                                <HistoryList
                                    type="auth"
                                    histories={histories}
                                    ELocale={this.state.ELocale}
                                />
                            </Section>
                        ) : null}
                    </>
                )}
            </>
        );
    }

    get renderTapSelector() {
        const { selectedTap, taps } = this.state;
        console.log("=====tab change - renderTapSelector=====");
        console.log(selectedTap);
        console.log(this.state);
        let detail = "";
        if (this.state.product[this.state.ELocale]) {
            if (selectedTap === 0) {
                detail = this.state.product[this.state.ELocale].detail;
            }
            if (selectedTap === 1) {
                detail = this.state.product[this.state.ELocale].detail2;
            }
            if (selectedTap === 2) {
                detail = this.state.product[this.state.ELocale].detail3;
            }
            console.log(this.state.product[this.state.ELocale]);
            console.log(this.state.product[this.state.ELocale].detail3);
        }
        return (
            <Section>
                <TapSelector
                    taps={taps}
                    selectedTap={selectedTap}
                    onClickTap={this.onClickTap.bind(this)}
                />

                <div
                    className={style.productImageContainer}
                    dangerouslySetInnerHTML={{ __html: detail }}
                />
            </Section>
        );
    }
    get renderHashTag() {
        if ((this.state.product[this.state.ELocale] || {}).tag && (this.state.product[this.state.ELocale] || {}).tag.length > 0) {
            return (
                <Section title={this.props.t("hash_tags")}>
                    <HashTag
                        tags={(this.state.product[this.state.ELocale] || {}).tag}
                        onClick={hashtag => this.handleHashtagLink(hashtag)}
                    />
                </Section>
            );
        } else{
            return null;
        }
    }

    get renderShopUrl() {
        const productLocale = this.state.product[this.state.ELocale] || {};
        const urls = productLocale.storeUrl;

        const openUrl = href => {
            if (
                window.webkit &&
                window.webkit.messageHandlers &&
                window.webkit.messageHandlers.iosHandler
            ) {
                Const.goLinkInIOS(href);
            } else {
                window.open(href);
            }
        };

        const hasUrl = Array.isArray(urls) ? urls.length > 0 : !!urls;
        if (hasUrl)
            return (
                <Section title={this.props.t("shop_tags")}>
                    <div style={{ padding: "8px 0" }}>
                        <a
                            href={urls}
                            onClick={e => {
                                e.preventDefault();
                                openUrl(urls);
                            }}
                            style={{ wordBreak: "break-all", textDecoration: "underline" }}
                        >
                            {urls}
                        </a>
                    </div>
                </Section>
            );
        else
            return null
    }

    get renderCompanyUrl() {
        const productLocale = this.state.product[this.state.ELocale] || {};
        const urls = productLocale.companyUrl;

        const openUrl = href => {
            if (
                window.webkit &&
                window.webkit.messageHandlers &&
                window.webkit.messageHandlers.iosHandler
            ) {
                Const.goLinkInIOS(href);
            } else {
                window.open(href);
            }
        };

        const hasUrl = Array.isArray(urls) ? urls.length > 0 : !!urls;
        if (hasUrl)
            return (
                <Section title={this.props.t("company_tags")}>
                    <div style={{ padding: "8px 0" }}>
                        <a
                            href={urls}
                            onClick={e => {
                                e.preventDefault();
                                openUrl(urls);
                            }}
                            style={{ wordBreak: "break-all", textDecoration: "underline" }}
                        >
                            {urls}
                        </a>
                    </div>
                </Section>
            );
        else
            return null
    }

    get renderModal() {
        const { modalVisible } = this.state;
        if (!modalVisible) return null;

        return (
            <div className={style.modal}>
                <div className={style.modalContent}>
                    <CloudfrontImage
                        className={style.winImage}
                        src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-win.svg"}
                        alt={"ic_win"}
                        logContext={{ component: 'Product', assetType: 'event-win' }}
                    />
                    <span className={style.modalTitle}>
            {this.state.product[this.state.ELocale + "CompanyName"]}
                        {this.props.t("has_event")}
          </span>
                    <span className={style.modalDescription}>
            {this.props.t("app_benefit_1")}
          </span>
                    <span className={style.modalDescription}>
            {this.props.t("app_benefit_2")}
          </span>
                    <span className={style.modalDescription}>
            {this.props.t("app_benefit_3")}
          </span>
                    <div
                        onClick={() => {
                            alert("앱 설치합니다");
                        }}
                        className={style.modalButton}
                    >
            <span className={style.modalButtonText}>
              {this.props.t("download_app")}
            </span>
                    </div>
                    <span
                        className={style.modalBottomText}
                        onClick={() => {
                            // this.props.history.push('/user/event?event_id=' + this.state.event._id + '&id=' + this.state.productReleaseCode);
                            this.setState({ modalVisible: false });
                        }}
                    >
            {this.props.t("view_on_web")}
          </span>
                </div>
            </div>
        );
    }

    get renderLoadFailed() {
        const { t } = this.props;
        return (
            <div className={style.container}>
                {this.state.isDetail ? null : (
                    <Header
                        content={t("authentication_result")}
                        onClosePress={e => {
                            Const.userAppCloseActivity();
                        }}
                    />
                )}
                <div
                    className={style.sectionContainer}
                    style={this.state.isDetail ? { paddingTop: 0 } : {}}
                >
                    <Section>
                        <div
                            style={{
                                padding: "48px 20px",
                                textAlign: "center",
                                lineHeight: 1.6,
                                whiteSpace: "pre-wrap",
                                color: "#333"
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 18,
                                    fontWeight: 600,
                                    marginBottom: 12
                                }}
                            >
                                {t("product_not_exist")}
                            </div>
                            <div style={{ fontSize: 14 }}>
                                {t("product_not_exist_detail")}
                            </div>
                        </div>
                    </Section>
                </div>
            </div>
        );
    }

    get loadingProgress() {
        return (
            <div className={style.loading_area}>
                <div className={style.loading_progress}>
                    <Spinner type={"SyncLoader"} color={"#ff7d40"} margin={"8px"} />
                </div>
                <div className={style.progress_text_area}>
          <span className={style.loading_font}>
            {this.props.t("authenticating")}
          </span>
                    <span className={style.loading_small_font}>
            {this.props.t("wait_moment")}
          </span>
                </div>
            </div>
        );
    }

    render() {
        const { t } = this.props;
        const productLocale = this.state.product[this.state.ELocale] || {};
        if (!this.state.product._id && this.state.productLoadFailed) {
            return this.renderLoadFailed;
        }

        return this.state.product._id ? (
            <div className={style.container}>
                {this.state.isDetail ? null : (
                    <Header
                        content={t("authentication_result")}
                        onClosePress={e => {
                            Const.userAppCloseActivity();
                        }}
                    />
                )}
                <div
                    className={style.sectionContainer}
                    style={this.state.isDetail ? { paddingTop: 0 } : {}}
                >
                    {this.renderFirstSection}
                    {this.renderSecondSection}
                    {productLocale.isMagnetic ? this.renderMagnetic : null}
                    {this.renderThirdSection}
                </div>
                {/*
                    <CameraFooter/>*/}

                {this.renderModal}
            </div>
        ) : this.state.isDetail ? null : (
            this.loadingProgress
        );
    }
}

export default connect(state => {
    return {
        eSESSION: state.data.eSESSION.eSESSION,
        COUNTRY_CODE: state.data.eSESSION.COUNTRY_CODE
    };
})(withRouter(withTranslation()(ProductContainer)));
